import type { MjlApp } from './config';

export function openApp(app: MjlApp): void {
  window.open(app.app_url, '_blank', 'noopener,noreferrer');
}

export function searchApps(apps: MjlApp[], query: string): MjlApp[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return apps;

  return apps.filter((app) => {
    const haystack = [
      app.app_name,
      app.app_initial_name,
      app.short_description ?? '',
      app.long_description ?? '',
    ]
      .join(' ')
      .toLowerCase();
    return haystack.includes(normalized);
  });
}
